<script setup lang="ts">
import { NMessageProvider, enGB, dateEnGB } from "naive-ui";
import {
    NNotificationProvider,
    NConfigProvider,
    NLoadingBarProvider,
} from "naive-ui";
import MessageProviderSetup from "@/Components/MessageProviderSetup.vue";
import NotificationHandler from "@/Components/NotificationHandler.vue";

const themeOverrides = {
    //...
};
</script>

<template>
    <NConfigProvider
        :locale="enGB"
        :date-locale="dateEnGb"
        :theme-overrides="themeOverrides"
    >
        <NMessageProvider>
            <NNotificationProvider>
                <NLoadingBarProvider
                    :loading-bar-style="{
                        loading: {
                            height: '3px',
                            backgroundColor: '#2e9236',
                            display: 'none',
                        },
                    }"
                >
                    <MessageProviderSetup />
                    <NotificationHandler />
                    <router-view
                        :key="$route.name"
                        v-slot="{ Component, route }"
                    >
                        <div :key="route.name">
                            <Component :is="Component" />
                        </div>
                    </router-view>
                </NLoadingBarProvider>
            </NNotificationProvider>
        </NMessageProvider>
    </NConfigProvider>
</template>
